var map = {
	"./Image1.png": 3788,
	"./Image2.png": 2263,
	"./Image3.png": 926,
	"./Image4.png": 7041,
	"./Image5.png": 7096,
	"./Image6.png": 3955,
	"./b6.avif": 7467,
	"./b6.jpg": 2992,
	"./b6.webp": 3833,
	"./base.css": 3014,
	"./js/commonscript": 1627,
	"./js/commonscript.js": 1627,
	"./logo.png": 3153,
	"./logo.svg": 3935,
	"./main.css": 10
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;